import { render, staticRenderFns } from "./chosePzNew.vue?vue&type=template&id=72751aec&scoped=true&"
import script from "./chosePzNew.vue?vue&type=script&lang=js&"
export * from "./chosePzNew.vue?vue&type=script&lang=js&"
import style0 from "./chosePzNew.vue?vue&type=style&index=0&id=72751aec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72751aec",
  null
  
)

export default component.exports